import { FileExtensionEnum } from "@enums";

export const POSSIBLE_ICONS_LIST = new Map([
    [FileExtensionEnum.SevenZip, { naming: 'Archive File', icon: 'zip' }],
    [FileExtensionEnum.Aif, { naming: 'Music file', icon: 'aif' }],
    [FileExtensionEnum.Arc, { naming: 'Archive File', icon: 'arc' }],
    [FileExtensionEnum.Avi, { naming: 'Video file', icon: 'avi' }],
    [FileExtensionEnum.Bmp, { naming: 'Image', icon: 'bmp' }],
    [FileExtensionEnum.Csv, { naming: 'Text file', icon: 'csv' }],
    [FileExtensionEnum.Doc, { naming: 'Word document', icon: 'doc' }],
    [FileExtensionEnum.Docx, { naming: 'Word document', icon: 'doc' }],
    [FileExtensionEnum.Dotx, { naming: 'Word document', icon: 'doc' }],
    [FileExtensionEnum.Flac, { naming: 'Music file', icon: 'other' }],
    [FileExtensionEnum.Gif, { naming: 'Image', icon: 'gif' }],
    [FileExtensionEnum.Jpeg, { naming: 'Image', icon: 'jpg' }],
    [FileExtensionEnum.Jpg, { naming: 'Image', icon: 'jpg' }],
    [FileExtensionEnum.M4r, { naming: 'Music file', icon: 'other' }],
    [FileExtensionEnum.Mov, { naming: 'Video file', icon: 'mov' }],
    [FileExtensionEnum.Mp3, { naming: 'Music file', icon: 'other' }],
    [FileExtensionEnum.Mp4, { naming: 'Video file', icon: 'mp4' }],
    [FileExtensionEnum.Odt, { naming: 'Text file', icon: 'other' }],
    [FileExtensionEnum.Pdf, { naming: 'PDF', icon: 'pdf' }],
    [FileExtensionEnum.Png, { naming: 'Image', icon: 'png' }],
    [FileExtensionEnum.Pot, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Potx, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Pps, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Ppt, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Pptm, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Pptx, { naming: 'Presentation', icon: 'ppt' }],
    [FileExtensionEnum.Rar, { naming: 'Archive File', icon: 'other' }],
    [FileExtensionEnum.Rtf, { naming: 'Text file', icon: 'rtf' }],
    [FileExtensionEnum.Sql, { naming: 'SQL file', icon: 'other' }],
    [FileExtensionEnum.Svg, { naming: 'Image', icon: 'other' }],
    [FileExtensionEnum.Tif, { naming: 'Image', icon: 'other' }],
    [FileExtensionEnum.Txt, { naming: 'Text file', icon: 'txt' }],
    [FileExtensionEnum.Webm, { naming: 'Video file', icon: 'other' }],
    [FileExtensionEnum.Webp, { naming: 'Image', icon: 'other' }],
    [FileExtensionEnum.Wma, { naming: 'Music file', icon: 'wma' }],
    [FileExtensionEnum.Wmf, { naming: 'Image', icon: 'wmf' }],
    [FileExtensionEnum.Wpd, { naming: 'Text file', icon: 'other' }],
    [FileExtensionEnum.Xls, { naming: 'Excel document', icon: 'xls' }],
    [FileExtensionEnum.Xlsb, { naming: 'Excel document', icon: 'xls' }],
    [FileExtensionEnum.Xlsm, { naming: 'Excel document', icon: 'xls' }],
    [FileExtensionEnum.Xlsx, { naming: 'Excel document', icon: 'xls' }],
    [FileExtensionEnum.Zip, { naming: 'Archive File', icon: 'zip' }],
]);

export default function getFileTypeIcon(fileExtension) {
    if (POSSIBLE_ICONS_LIST.has(fileExtension)) {
        return `file-${POSSIBLE_ICONS_LIST.get(fileExtension).icon}`;
    }

    return 'file-other';
}

export function getFileTypeNaming(fileExtension) {
    if (POSSIBLE_ICONS_LIST.has(fileExtension)) {
        return POSSIBLE_ICONS_LIST.get(fileExtension).naming;
    }

    return 'other';
}
